import { render, staticRenderFns } from "./ConfigurationPrice.vue?vue&type=template&id=3f4a37b4&scoped=true&"
import script from "./ConfigurationPrice.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationPrice.vue?vue&type=style&index=0&id=3f4a37b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a37b4",
  null
  
)

export default component.exports